export default __webpack_public_path__ + "static/media/container2.f48ea513.jpg";